// extracted by mini-css-extract-plugin
export var conceptInfo = "GameConceptsManager-module__conceptInfo___gCMF1";
export var conceptList = "GameConceptsManager-module__conceptList___0quJp";
export var conceptMeta = "GameConceptsManager-module__conceptMeta___w4PL4";
export var conceptProgress = "GameConceptsManager-module__conceptProgress___o3euH";
export var conceptProgressBar = "GameConceptsManager-module__conceptProgressBar___81VMa";
export var conceptProgressLabel = "GameConceptsManager-module__conceptProgressLabel___r42ua";
export var conceptRow = "GameConceptsManager-module__conceptRow___BhFPn";
export var conceptTitle = "GameConceptsManager-module__conceptTitle___bcU1W";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var createButton = "GameConceptsManager-module__createButton___4sgtt";
export var deleteModalActions = "GameConceptsManager-module__deleteModalActions___6fZox";
export var deleteModalBody = "GameConceptsManager-module__deleteModalBody___tzVvq";
export var deleteModalCancel = "GameConceptsManager-module__deleteModalCancel___l6-Rt";
export var deleteModalClose = "GameConceptsManager-module__deleteModalClose___+BPS-";
export var deleteModalConfirm = "GameConceptsManager-module__deleteModalConfirm___1pVvm";
export var deleteModalHeader = "GameConceptsManager-module__deleteModalHeader___MSnFc";
export var deleteModalTitle = "GameConceptsManager-module__deleteModalTitle___xj4MG";
export var disabledNavButton = "GameConceptsManager-module__disabledNavButton___gLdml";
export var dotApproved = "GameConceptsManager-module__dotApproved___5WHym";
export var dotDraft = "GameConceptsManager-module__dotDraft___8TmCG";
export var dotRejected = "GameConceptsManager-module__dotRejected___dKqRH";
export var dotReview = "GameConceptsManager-module__dotReview___6EMnZ";
export var dotWarning = "GameConceptsManager-module__dotWarning___dxZZo";
export var emptyState = "GameConceptsManager-module__emptyState___M8Zks";
export var emptyStateButton = "GameConceptsManager-module__emptyStateButton___i7+e8";
export var emptyStateDescription = "GameConceptsManager-module__emptyStateDescription___wunk2";
export var emptyStateTitle = "GameConceptsManager-module__emptyStateTitle___AeppP";
export var expandSearch = "GameConceptsManager-module__expandSearch___BDtkS";
export var fadeIn = "GameConceptsManager-module__fadeIn___MtLoW";
export var filterDropdown = "GameConceptsManager-module__filterDropdown___asDhM";
export var filterPopup = "GameConceptsManager-module__filterPopup___BmYHn";
export var filtersRow = "GameConceptsManager-module__filtersRow___mPr9N";
export var headerActions = "GameConceptsManager-module__headerActions___h5Utj";
export var iconButton = "GameConceptsManager-module__iconButton___F8njs";
export var lastEdited = "GameConceptsManager-module__lastEdited___vK-Hh";
export var managerContainer = "GameConceptsManager-module__managerContainer___iSdFA";
export var managerHeader = "GameConceptsManager-module__managerHeader___mwv1F";
export var managerTitle = "GameConceptsManager-module__managerTitle___VKnVt";
export var moreButton = "GameConceptsManager-module__moreButton___Y3AOP";
export var moreMenu = "GameConceptsManager-module__moreMenu___Xs8GU";
export var moreMenuItem = "GameConceptsManager-module__moreMenuItem___YEN8j";
export var moreMenuWrapper = "GameConceptsManager-module__moreMenuWrapper___j2r-B";
export var navButtonsContainer = "GameConceptsManager-module__navButtonsContainer___mBODQ";
export var navigationButton = "GameConceptsManager-module__navigationButton___xRgRD";
export var noGameConceptsMessage = "GameConceptsManager-module__noGameConceptsMessage___W7oto";
export var programBadge = "GameConceptsManager-module__programBadge___bAgq+";
export var programBadges = "GameConceptsManager-module__programBadges___Fo11m";
export var resubmitNote = "GameConceptsManager-module__resubmitNote___aBDj6";
export var searchBox = "GameConceptsManager-module__searchBox___PyJOO";
export var searchClose = "GameConceptsManager-module__searchClose___kw3gr";
export var searchExpanded = "GameConceptsManager-module__searchExpanded___MBp2l";
export var searchIcon = "GameConceptsManager-module__searchIcon___Ia5CF";
export var searchInput = "GameConceptsManager-module__searchInput___3vLAi";
export var spinnerFullWidth = "GameConceptsManager-module__spinnerFullWidth___YVrG4";
export var statusApproved = "GameConceptsManager-module__statusApproved___12rL8";
export var statusDot = "GameConceptsManager-module__statusDot___BQ1yi";
export var statusDraft = "GameConceptsManager-module__statusDraft___UAnMb";
export var statusLabel = "GameConceptsManager-module__statusLabel___VeKnY";
export var statusRejected = "GameConceptsManager-module__statusRejected___6hNUV";
export var statusReview = "GameConceptsManager-module__statusReview___eeTJb";
export var statusWarning = "GameConceptsManager-module__statusWarning___38oDH";